export const GET_USER_DETAILS_REQUEST = 'GET_USER_DETAILS_REQUEST';
export const GET_USER_DETAILS_REQUEST_SUCCESS =
  'GET_USER_DETAILS_REQUEST_SUCCESS';
export const GET_USER_DETAILS_REQUEST_ERROR = 'GET_USER_DETAILS_REQUEST_ERROR';
